<template>
  <div class="document" style="height:100%">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Role Manager
          </div>
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <div>
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th title="Role Name">
                Role Name
              </th>
              <th title="Actions">
                Actions
              </th>
            </tr>
          </thead>
          <tbody v-if="roles !== undefined">
            <tr v-for="role in sortedRoles" v-bind:key="role.id">
              <td class="table-body">
                <span v-if="role.name">
                  {{ role.name }}
                </span>
              </td>
              <td class="table-action" style="text-align: end">
                <div class="icon">
                  <router-link :to="{ path: `roles/${role.id}/privileges` }">
                    <font-awesome-icon
                      :icon="['far', 'angle-double-right']"
                      class="fa-2x"
                      title="View Details"
                    />
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDoubleRight } from '@fortawesome/pro-regular-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faAngleDoubleRight,
);
export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  components: {
    EsHeader,
  },
  props: {
    roles: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      allModules: 'appModules/getAllModules',
    }),
    sortedRoles() {
      return this.roles.slice().sort((a, b) => (a.name > b.name ? 1 : -1));
    },
  },
  created() {
    this.setBreadcrumb([
      { text: 'Security Manager', to: {} },
    ]);
  },
};
</script>

  <style lang="sass" scoped>
    .no-result-container
      padding: 6.5rem
      </style>
